import { render, staticRenderFns } from "./AnswersTable.vue?vue&type=template&id=e2133028&scoped=true&functional=true"
import script from "./AnswersTable.vue?vue&type=script&lang=js"
export * from "./AnswersTable.vue?vue&type=script&lang=js"
import style0 from "./AnswersTable.vue?vue&type=style&index=0&id=e2133028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "e2133028",
  null
  
)

export default component.exports